import { getManagementTermsTabFetchParams } from "helpers/managementGeneralTabFetchParams";
import { getGeneralTabData } from "store/managementStore";
import type { AppDispatch } from "store/store";

/**
 * Refetches the Management "Général" table (advanceAmount, etc.) after advance create/update/delete.
 * Uses the same parameters as the persisted tab (see `getManagementTermsTabFetchParams`) when
 * the table is not mounted. From Management, pass `refetchGeneralTab: handleRequest` to modals
 * so the request matches live `useAPIPagination` state.
 */
export async function refetchManagementGeneralTab(dispatch: AppDispatch, activePeriodId: number | undefined) {
    if (!activePeriodId) {
        return;
    }
    return dispatch(getGeneralTabData(getManagementTermsTabFetchParams(activePeriodId)));
}
